import { useMemo } from 'react';

import {
  managedByAutoneToBoolean,
  matchSystemRecommendationToBoolean,
} from '../../../../../utils/quick-filters';
import {
  useAssortmentAdvancedFilters,
  useAssortmentGeneralFilters,
} from '../../../../hooks';
import { type GetAssortmentSkuLocationsRequest } from '../../../../redux/assortment';
import { useAssortmentSessionStorageAtom } from '../../../../storage/session-storage';
import { type AssortmentSkuLocationsSortKeys } from '../SkuLocationsTable.utilities';

interface UseGetSkuLocationsTableQueryArgsProps {
  searchTerm: string;
  sortBy?: AssortmentSkuLocationsSortKeys;
}

export const useGetSkuLocationsTableQueryArgs = ({
  searchTerm,
  sortBy,
}: UseGetSkuLocationsTableQueryArgsProps) => {
  const { selectedGeneralFiltersApi } =
    useAssortmentGeneralFilters('skuLocationsTable');
  const { selectedAdvancedFiltersApi } =
    useAssortmentAdvancedFilters('skuLocationsTable');
  const [{ managedByAutoneToggle, matchSystemRecommendationToggle }] =
    useAssortmentSessionStorageAtom('skuLocationsTable.extrasMenu');
  const isManagedByAutone = managedByAutoneToBoolean(managedByAutoneToggle);
  const matchesSystemRecommendation = matchSystemRecommendationToBoolean(
    matchSystemRecommendationToggle,
  );

  const queryArgs: GetAssortmentSkuLocationsRequest = useMemo(() => {
    return {
      body: {
        filters: {
          ...selectedGeneralFiltersApi,
          sku_location_search_term: searchTerm,
        },
        advanced_filter: selectedAdvancedFiltersApi,
        is_managed_by_user:
          isManagedByAutone === null ? null : !isManagedByAutone,
        matches_system_recommendation: matchesSystemRecommendation,
      },
      query: { sort_by: sortBy },
    };
  }, [
    sortBy,
    searchTerm,
    selectedGeneralFiltersApi,
    selectedAdvancedFiltersApi,
    isManagedByAutone,
    matchesSystemRecommendation,
  ]);

  return queryArgs;
};
